<template>
  <div class="item-wrap">
    <div class="membership-item">
      <div class="title">
        <div class="title-left">
          <div class="is-12m">비회원이시라면</div>
          <div class="is-16b cursor" @click="onClickDetail('0', true, 'apply')">신규 가입 신청</div>
        </div>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2408_6854)">
            <path
              d="M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9457 14 14.251V14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18 17V14H20V17H23V19H20V22H18V19H15V17H18Z"
              fill="#21272A"
            />
          </g>
          <defs>
            <clipPath id="clip0_2408_6854">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="tag-wrap cursor" @click="onClickDetail('0')">
        <div class="is-12r">운영방법 및 회원혜택</div>
      </div>
    </div>
    <div class="membership-item">
      <div class="title">
        <div class="title-left">
          <div class="is-12m">회원전용</div>
          <div class="is-16b cursor" @click="onClickDetail('1', true)">이달의 미팅 참가 신청</div>
        </div>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5 19.0001H6.414L15.728 9.68608L14.314 8.27208L5 17.5861V19.0001ZM21 21.0001H3V16.7571L16.435 3.32208C16.6225 3.13461 16.8768 3.0293 17.142 3.0293C17.4072 3.0293 17.6615 3.13461 17.849 3.32208L20.678 6.15108C20.8655 6.33861 20.9708 6.59292 20.9708 6.85808C20.9708 7.12325 20.8655 7.37756 20.678 7.56508L9.243 19.0001H21V21.0001ZM15.728 6.85808L17.142 8.27208L18.556 6.85808L17.142 5.44408L15.728 6.85808Z"
            fill="#21272A"
          />
        </svg>
      </div>
      <div class="tag-wrap">
        <div class="is-12r cursor" @click="onClickDetail('3', true)">정보자료</div>
        <div class="is-12r cursor" @click="onClickDetail('2', true)">미팅 동영상</div>
        <div class="is-12r cursor" @click="onClickDetail('4')">포토존</div>
      </div>
    </div>
  </div>
</template>

<script>
import {useMemberStore} from '~/store/member'
import {useMembershipStore} from '~/store/membership/index.js'

export default {
  setup() {
    const memberStore = useMemberStore()
    const membershipStore = useMembershipStore()
    return {
      memberStore,
      membershipStore
    }
  },
  props: {
    menu: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isAuth: false
    }
  },
  mounted() {
    this.isAuth = this.memberStore.isAuthenticated
  },
  methods: {
    async onClickDetail(subMenu, loginRequired = false, apply) {
      if (loginRequired) {
        if (!this.isAuth) {
          alert('로그인 후 이용 가능합니다.')
        } else {
          // 회원사업 타입
          const memberTypeMap = {
            0: 'MMT01',
            1: 'MMT02',
            2: 'MMT03',
            3: 'MMT04'
          }
          // 구독여부 체크
          const {data} = await this.membershipStore.getMembershipSubscribe(memberTypeMap[this.menu])
          const isSubscribe = data.isSubscribe
          if (!isSubscribe) {
            alert('회원사업 가입 후 이용 가능합니다.')
          } else if (apply) {
            this.$router.push(`/membership-business?menu=${this.menu}&subMenu=${subMenu}&apply=${apply}`)
          } else {
            this.$router.push(`/membership-business?menu=${this.menu}&subMenu=${subMenu}`)
          }
        }
      } else {
        this.$router.push(`/membership-business?menu=${this.menu}&subMenu=${subMenu}`)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.item-wrap {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.membership-item {
  border-radius: 10px;
  padding: 6px 12px;
  background: #fff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  width: 220px;
  margin: 0 auto;

  .title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;

    .title-left {
      display: flex;
      flex-direction: column;
      text-align: left;

      .is-12m {
        color: #606060;
      }
    }
  }

  .tag-wrap {
    text-align: left;
    display: flex;
    gap: 2px;

    .is-12r {
      border-radius: 100px;
      border: 1px solid #dbdbdb;
      padding: 4px 8px;
      color: #606060;
      display: inline-flex;
    }
  }
}
</style>
